<template>
    <servicos
        :permitirAprovar="$temAcessoView('GESCON-UFI-APROV-00')"
        :permitirReprovar="$temAcessoView('GESCON-UFI-APROV-00')"
        :permiteDetalhar="$temAcessoView('GESCON-UFI-APROV-00')"
        rotaDetalhar="Gescon_Financeiro_Servicos_Detalhar"
        rotaListagem="Gescon_Financeiro_Servicos_Listagem"
    ></servicos>
</template>

<script>
import ServicosServicos from './ServicosServicos'
import Servicos from '../../aprovadores/Comprometimentos'

export default {
    name: 'FinanceiroServicos',
    
    components: {
        Servicos
    },

    data() {
        return {
            servicosServicos: ServicosServicos
        }
    },

    provide() {
        return {
            servicosServicos: this.servicosServicos
        }
    }
}
</script>
